var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 66.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0030d5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.01,0c.96,0,1.37,1.22.61,1.8l-35.7,27.2-5.78,4.4-4.52,3.45c-.36.27-.85.27-1.21,0l-4.52-3.45-5.78-4.4L2.39,1.8c-.76-.58-.35-1.8.61-1.8h92.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.27,34.19L1.61,56.79c-.66.5-1.61.03-1.61-.8V10.8c0-.83.95-1.3,1.61-.8l29.66,22.59c.53.4.53,1.19,0,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.52,38.26l34.93,26.6c.76.58.35,1.8-.61,1.8H3.16c-.96,0-1.37-1.22-.61-1.8l34.93-26.6c.36-.27.85-.27,1.21,0l8.18,6.23c.63.48,1.37.72,2.12.72s1.49-.24,2.12-.72l8.18-6.23c.36-.27.85-.27,1.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98,10.8v45.19c0,.83-.95,1.3-1.61.8l-29.66-22.6c-.53-.4-.53-1.19,0-1.59l29.66-22.59c.66-.5,1.61-.03,1.61.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0f79a8d56aaa078754bf5aba64d15dd3.svg";
export { ForwardRef as ReactComponent };